import { styled } from "@mui/material/styles";
import { Badge, Card, Grid, TableCell, Tabs } from "@mui/material";
import { useColors } from "../../Context/ColorsContext"
import { MediaQuerys } from "../../styles/GlobalStyle";

const { mobile, tablet, desktop } = MediaQuerys;

export const TitleSection = styled("section")(() => ({
  display: "flex",
  height: "auto",
  width: "100%",
  justifyContent: "space-between",
  flexDirection: "row",
  alignItems: "center",
  marginBottom: '10px',
}));

export const SearchContainer = styled("div")(() => ({
  display: 'flex',
  alignItems: 'center',
  width: "50%",
  justifyContent: "flex-end",
  [tablet]: {
    width: "auto",
  }
}));

export const HiddenMobileDownloadContainer = styled("div")(() => ({
  display: 'block',
  [tablet]: {
    display: 'none'
  }
}));

export const CustomCard = styled(Card)(() => ({
  minHeight: 430,
  maxHeight: "calc(100vh - 100px)",
  width: "100%",
  borderRadius: 6,
  boxShadow: "rgb(61 71 82 / 20%) 0px 4px 8px",
  padding: "30px 20px",
}));

export const SectionPageTitle = styled("section")(() => ({
  display: "flex",
  width: "100%",
}));

export const CustomTableCell = styled(TableCell)(() => {
  const { colors } = useColors();  
  return {
    color: colors.main,
    fontSize: "12px",
    fontWeight: 600,
  }
});

export const TableCellStatus = styled(TableCell)(() => ({
  display: "flex",
}));
export const ContainerCell = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
}));

export const SectionInfo = styled("section")(() => ({
  display: "flex",
  flexDirection: "column",
}));

export const InfoCell = styled("div")(() => ({}));

export const TitleCell = styled("p")(() => {
  const { colors } = useColors();  
  return {
    fontSize: '0.875rem', 
    color: colors.grayFont
  }
});

export const Spacer = styled("div")(() => ({
  display: "flex",
  flex: 1,
}));

export const ContainersButtonsGroup = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  [tablet]: {
    justifyContent: 'flex-end',
    alignItems: 'center',
  }
}))

export const CustomTab = styled('div')(() => {
  return {
    display: 'flex',
    alignItems: 'stretch',
    paddingLeft: 8,
    cursor: 'pointer',
  };
});

export const TabInner = styled('div')(() => ({
  borderRadius: 8,
  padding: '0 2px',
  display: 'flex',
  alignItems: 'center',
  height: '100%',
}));

export const CustomBadge = styled(Badge)(() => {
  return {
    marginTop: 0,
    marginRight: 15,
    position: 'relative',
    '& .MuiBadge-badge': {
      backgroundColor: '#b7cbe4',
      color: '#68798f',
      top: '50%',
      right: '-12px',
      transform: 'translateY(-50%)',
      fontSize: '0.8rem',
      fontWeight: 600,
      border: '1px solid #b7cbe4',
    }
  }
});

export const Title = styled('p')(() => {
  const { colors } = useColors();
  return {
    color: colors.titleTextColor,
    textAlign: "center",
    alignContent: "center",
    fontWeight: "700",
    fontSize: '1.5rem',
    [desktop]: {
      width: '100px',
      fontSize: '0.75rem',
    },
    [mobile]: {
      fontSize: '0.75rem',
    },
  };
});

export const GridItem = styled(Grid)(({theme}) => {
  return {
    [theme.breakpoints.down('md')]: {
      display: 'none'
    }
  };
}); 